export const url_data_set = {
    super_z: "https://runningcrew.oopy.io",
    hard_study: "https://hardstudy.oopy.io",
    credit_bank: "https://bearu-edu.oopy.io",
};